import { render, staticRenderFns } from "./MandatoryPackage.vue?vue&type=template&id=aed5cf06&scoped=true&"
import script from "./MandatoryPackage.vue?vue&type=script&lang=js&"
export * from "./MandatoryPackage.vue?vue&type=script&lang=js&"
import style0 from "./MandatoryPackage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MandatoryPackage.vue?vue&type=style&index=1&id=aed5cf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed5cf06",
  null
  
)

export default component.exports